/* GGSPK Goshala — scripts.js */
(function(){
'use strict';

/* ── HEADER SCROLL ── */
var hdr=document.getElementById('H');
if(hdr) window.addEventListener('scroll',function(){
  hdr.classList.toggle('scrolled',window.scrollY>40);
},{passive:true});

/* ── MOBILE MENU ── */
window.mobOpen=function(){
  document.getElementById('MN').classList.add('op');
  document.getElementById('MB').classList.add('on');
  var h=document.getElementById('HAM');
  if(h){h.classList.add('op');h.setAttribute('aria-expanded','true');}
  document.body.style.overflow='hidden';
};
window.mobClose=function(){
  document.getElementById('MN').classList.remove('op');
  document.getElementById('MB').classList.remove('on');
  var h=document.getElementById('HAM');
  if(h){h.classList.remove('op');h.setAttribute('aria-expanded','false');}
  document.body.style.overflow='';
};
window.mSub=function(btn){
  var sub=btn.nextElementSibling;
  if(sub) sub.classList.toggle('op');
  var arr=btn.querySelector('span:last-child');
  if(arr) arr.style.transform=(sub&&sub.classList.contains('op'))?'rotate(180deg)':'';
};

/* ── CART DRAWER ── */
window.openCart=function(){
  document.getElementById('CO').classList.add('on');
  document.getElementById('CD').classList.add('on');
  document.body.style.overflow='hidden';
  loadCart();
};
window.closeCart=function(){
  document.getElementById('CO').classList.remove('on');
  document.getElementById('CD').classList.remove('on');
  document.body.style.overflow='';
};

function loadCart(){
  fetch('/cart.js')
    .then(function(r){return r.json();})
    .then(function(c){renderCart(c);updBadge(c.item_count);})
    .catch(function(e){console.error(e);});
}

function renderCart(cart){
  var body=document.getElementById('CI');
  var foot=document.getElementById('CF');
  if(!body) return;

  if(!cart||!cart.items||cart.items.length===0){
    body.innerHTML='<div class="cd-empty"><div style="font-size:2.8rem;margin-bottom:10px">🛒</div><p>Your cart is empty.</p><a href="/collections/all" class="btn-g btn-sm" onclick="closeCart()" style="margin-top:12px;display:inline-flex">Shop Now</a></div>';
    if(foot) foot.style.display='none';
    body.style.opacity=1;
    return;
  }

  body.innerHTML=cart.items.map(function(item){
    /* ✅ USE item.key not item.id — key is unique per line item */
    var k=JSON.stringify(item.key);
    var img=item.image
      ?'<img src="'+item.image+'" loading="lazy" style="width:100%;height:100%;object-fit:cover">'
      :'<span style="font-size:1.8rem">🌿</span>';
    var vr=(item.variant_title&&item.variant_title!=='Default Title')
      ?'<div class="cd-vr">'+item.variant_title+'</div>':'';
    return '<div class="cd-item">'+
      '<div class="cd-img">'+img+'</div>'+
      '<div class="cd-info">'+
        '<div class="cd-nm">'+item.product_title+'</div>'+vr+
        '<div class="cd-pr">₹'+(item.final_line_price/100).toLocaleString('en-IN')+'</div>'+
        '<div class="cd-qty">'+
          '<button class="cd-qb" onclick="cQty('+k+','+Math.max(0,item.quantity-1)+')">−</button>'+
          '<span class="cd-qn">'+item.quantity+'</span>'+
          '<button class="cd-qb" onclick="cQty('+k+','+(item.quantity+1)+')">+</button>'+
          '<button class="cd-rm" onclick="cQty('+k+',0)">Remove</button>'+
        '</div>'+
      '</div>'+
    '</div>';
  }).join('');

  var t=document.getElementById('CT');
  if(t) t.textContent='₹'+(cart.total_price/100).toLocaleString('en-IN');
  if(foot) foot.style.display='block';
  body.style.opacity=1;
}

/* ✅ cQty uses item.key — fixes blank/flicker issue */
window.cQty=function(key,qty){
  if(qty<0) return;
  var body=document.getElementById('CI');
  if(body) body.style.opacity=0.5;
  fetch('/cart/change.js',{
    method:'POST',
    headers:{'Content-Type':'application/json'},
    body:JSON.stringify({id:key, quantity:qty})
  })
  .then(function(r){return r.json();})
  .then(function(c){renderCart(c);updBadge(c.item_count);})
  .catch(function(e){
    console.error(e);
    if(body) body.style.opacity=1;
  });
};

/* ADD TO CART */
window.shopCart=function(variantId,qty,btn){
  qty=qty||1;
  if(btn){btn.textContent='Adding…';btn.disabled=true;}
  fetch('/cart/add.js',{
    method:'POST',
    headers:{'Content-Type':'application/json'},
    body:JSON.stringify({id:variantId,quantity:qty})
  })
  .then(function(r){return r.json();})
  .then(function(item){
    if(item.title) toast('✅ '+item.title+' added!');
    if(btn){btn.textContent='🛒 Add to Cart';btn.disabled=false;}
    return fetch('/cart.js');
  })
  .then(function(r){return r.json();})
  .then(function(c){updBadge(c.item_count);openCart();})
  .catch(function(e){
    console.error(e);
    if(btn){btn.textContent='🛒 Add to Cart';btn.disabled=false;}
  });
};

window.demoCart=function(name,emoji,price,btn){
  if(btn){btn.textContent='Adding…';btn.disabled=true;}
  setTimeout(function(){
    toast('✅ '+name+' added!');
    if(btn){btn.textContent='🛒 Add to Cart';btn.disabled=false;}
  },400);
};

window.updBadge=function(n){
  var b=document.getElementById('CB');
  if(b){b.textContent=n;b.style.display=n>0?'flex':'none';}
};

fetch('/cart.js').then(function(r){return r.json();}).then(function(c){updBadge(c.item_count);}).catch(function(){});

/* ── SEARCH ── */
window.openSearch=function(){
  document.getElementById('SM').classList.add('on');
  setTimeout(function(){
    var f=document.getElementById('SI');
    if(f){f.focus();f.value='';}
    var sr=document.getElementById('SR');
    if(sr) sr.innerHTML='';
  },80);
};
window.closeSrch=function(e){
  if(e.target===document.getElementById('SM'))
    document.getElementById('SM').classList.remove('on');
};
window.doSearch=function(q){
  var el=document.getElementById('SR');
  if(!el) return;
  if(!q||q.length<2){el.innerHTML='';return;}
  fetch('/search/suggest.json?q='+encodeURIComponent(q)+'&resources[type]=product&resources[limit]=6')
    .then(function(r){return r.json();})
    .then(function(data){
      var prods=(data.resources&&data.resources.results&&data.resources.results.products)||[];
      if(!prods.length){el.innerHTML='<div style="font-size:.8rem;color:#6B5A3A;padding:10px 0">No products found.</div>';return;}
      el.innerHTML=prods.map(function(p){
        var img=p.image?'<img src="'+p.image+'" loading="lazy" style="width:100%;height:100%;object-fit:cover;border-radius:6px">':'🌿';
        var price=p.price?'₹'+(parseInt(p.price,10)/100).toLocaleString('en-IN'):'';
        return '<a style="display:flex;align-items:center;gap:11px;padding:9px;border-radius:8px;text-decoration:none" href="'+p.url+'" onmouseover="this.style.background=\'#EEF5E8\'" onmouseout="this.style.background=\'\'" onclick="document.getElementById(\'SM\').classList.remove(\'on\')">'+
          '<div style="width:42px;height:42px;border-radius:6px;background:#F6F0E4;display:flex;align-items:center;justify-content:center;font-size:1.3rem;flex-shrink:0;overflow:hidden">'+img+'</div>'+
          '<div><div style="font-size:.82rem;font-weight:600;color:#1C140A">'+p.title+'</div>'+
          '<div style="font-size:.76rem;color:#7A5C1E;font-weight:600">'+price+'</div></div></a>';
      }).join('');
    }).catch(function(){el.innerHTML='';});
};

/* ── WISHLIST ── */
window.wsh=function(btn){
  btn.classList.toggle('on');
  btn.textContent=btn.classList.contains('on')?'♥':'♡';
  btn.style.color=btn.classList.contains('on')?'#e74c3c':'';
  toast(btn.classList.contains('on')?'♥ Added to wishlist!':'Removed from wishlist');
};

/* ── TOAST ── */
var _tt;
window.toast=function(msg){
  var el=document.getElementById('Toast');
  if(!el) return;
  el.textContent=msg;
  el.classList.add('on');
  clearTimeout(_tt);
  _tt=setTimeout(function(){el.classList.remove('on');},2800);
};

/* ── ACCORDION ── */
document.addEventListener('click',function(e){
  var hd=e.target.closest('.acc-hd');
  if(hd) hd.closest('.acc-item').classList.toggle('op');
});

/* ── PRODUCT PAGE QTY ── */
window.qChg=function(d){
  var el=document.getElementById('QN');
  var inp=document.getElementById('QIn');
  if(el){var n=Math.max(1,(parseInt(el.textContent)||1)+d);el.textContent=n;if(inp)inp.value=n;}
};
window.setThumb=function(btn,src,alt){
  var img=document.getElementById('GMImg');
  if(img){img.src=src;if(alt)img.alt=alt;}
  document.querySelectorAll('.g-th').forEach(function(t){t.classList.remove('on');});
  btn.classList.add('on');
};

/* ── SCROLL REVEAL ── */
var obs=new IntersectionObserver(function(entries){
  entries.forEach(function(e){
    if(e.isIntersecting){e.target.classList.add('vis');obs.unobserve(e.target);}
  });
},{threshold:0.07});
document.querySelectorAll('.rv').forEach(function(el){obs.observe(el);});

}());